import { useEffect, useState } from 'react';

import { breakpointLD, breakpointMB, breakpointSD, breakpointTB } from '@flipster/utils/constants/breakpoint';
import { isServer } from '@flipster/utils/env-helper';
import { valueof } from '@flipster/utils/typescript';

export const BREAK_POINTS = {
  BP_MOBILE: 'MB',
  BP_TABLET: 'TB',
  BP_SMALL_DESKTOP: 'SD',
  BP_LARGE_DESKTOP: 'LD',
  BP_HUGE_DESKTOP: 'HD',
} as const;

const getCurrentBreakPoint = () => {
  if (isServer) return BREAK_POINTS.BP_MOBILE;
  const width = window.innerWidth;
  if (width >= Number(breakpointLD)) return BREAK_POINTS.BP_HUGE_DESKTOP;
  if (width >= Number(breakpointSD)) return BREAK_POINTS.BP_LARGE_DESKTOP;
  if (width >= Number(breakpointTB)) return BREAK_POINTS.BP_SMALL_DESKTOP;
  if (width >= Number(breakpointMB)) return BREAK_POINTS.BP_TABLET;
  return BREAK_POINTS.BP_MOBILE;
};

/**
 * @deprecated
 */
export function useResponsive() {
  const [bp, setBp] = useState<valueof<typeof BREAK_POINTS>>(getCurrentBreakPoint());

  useEffect(() => {
    const handler = () => setBp(getCurrentBreakPoint());

    window.addEventListener('resize', handler);
    return () => {
      window.removeEventListener('resize', handler);
    };
  }, []);

  const isMobile = bp === BREAK_POINTS.BP_MOBILE;
  const isTablet = bp === BREAK_POINTS.BP_TABLET;
  const isSmallDesktop = bp === BREAK_POINTS.BP_SMALL_DESKTOP;
  const isLargeDesktop = bp === BREAK_POINTS.BP_LARGE_DESKTOP;
  const isHugeDesktop = bp === BREAK_POINTS.BP_HUGE_DESKTOP;

  return {
    isMobile,
    isTablet,
    isSmallDesktop,
    isLargeDesktop,
    isHugeDesktop,
    isDesktop: isSmallDesktop || isLargeDesktop || isHugeDesktop,
  };
}
